/*
  Project: Urodziny Rybki MiniMini
  Author: Krzysztof Malina
*/
//import $ from 'jquery';

var mobileNav = require('./mobilenav.js');
var animations = require('./animations.js');
var konkurs = require('./konkursMM.js');
var player = require('./video.js');
//var enchancedSelect = require('./select.js');
var lightbox = require('./lightbox.js');
var slider = require('./slider.js');
import inputDate from './input-date';

konkurs();
animations();
mobileNav();
//enchancedSelect();
player();
lightbox();
slider();
inputDate();
